import { getTemplateLanguage } from '@/utils/language'
import Vue from 'vue'
import manager from '../manager'
import { formatPrice } from '@/utils/currency'
import { formatTime, formatDurarion, formatDurarionAsHours, formatDurarionDay } from '@/utils/timeFormat'
import { getLink } from '@/api/link';
import $ from 'jquery'
import { addCart } from '@/api/cart'
import { getPromotionState } from '@/api/promotion'
import { scaleImageByZoom } from '@/utils/imgUrl'
import { activeAllLazyImageDom } from '@/view/lib/lazy'


manager.add('spike', {
    created() {
        activeAllLazyImageDom(this.dom)
        try {
            var configData = JSON.parse($(this.dom).find(".configData").text())
            var styleData = JSON.parse($(this.dom).find(".styleData").text())
        } catch (err) {
            console.warn('秒杀数据解析错误')
        }
        var language = getTemplateLanguage()
        this.instance = new Vue({
            el: this.dom,
            data: {
                list: [],
                tab: -1,
                styleData,
                loading: true
            },
            created() {
                this.stateChange()
                this.refreshTime()
                this.timer = setInterval(() => this.refreshTime(), 1000)
            },
            destroyed() {
                clearInterval(this.timer)
            },
            methods: {
                formatTime,
                formatDurarion,
                formatDurarionAsHours,
                formatDurarionDay,
                getLink,
                addCart,
                getLocalStr(obj) {
                    return obj ? (obj[language] || obj) : ""
                },
                async stateChange() {
                    var list = configData.spike || []
                    var now = Date.now()
                        //过滤超出当前场次时间范围外的商品
                        // list.forEach(screen => {
                        //     screen.goods = (screen.goods||[]).filter(item => {
                        //         if (screen.startTime < item.timeBegin || screen.endTime > item.timeEnd) {
                        //             return false
                        //         }
                        //         return true
                        //     })
                        // })
                        // state 1:未开始 2:正在进行 3:已结束
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].startTime > now) {
                            list[i].state = 1
                        } else if (list[i].startTime < now && list[i].endTime > now) {
                            list[i].state = 2
                        } else if (list[i].endTime < now) {
                            list[i].state = 3
                        }
                        list[i].title = this.getLocalStr(list[i].title)
                        list[i].goods = (list[i].goods || []).map(it => ({
                            ...it,
                            skuName: this.getLocalStr(it.aliasName) || it.skuName,
                            description: this.getLocalStr(it.description),
                            imgUrl: scaleImageByZoom(it.aliasImgUrl || it.imgUrl, 'n7'),
                            superscriptStr: this.getLocalStr(it.superscript),
                            superscript2Str: this.getLocalStr(it.superscript2),
                        }))
                    }
                    //场次轮换
                    var ScreenCount = styleData.ScreenCount || 30
                    if (ScreenCount < list.length) {
                        let finded = false
                        for (let i = 0; i < list.length; i += ScreenCount) {
                            let _list = list.slice(i, i + ScreenCount)
                                //当这一批不足设定个数
                            if (_list.length != ScreenCount) {
                                break
                            }
                            let k = -1
                            for (let j = 0; j < _list.length; j++) {
                                if (_list[j].state != 3) {
                                    k = j
                                    break
                                }
                            }
                            if (k > -1) {
                                if (styleData.Prepend) {
                                    let __list = list.slice(i + k, i + k + ScreenCount)
                                        //设定了前置且这一批不足设定个数
                                    if (__list.length != ScreenCount) {
                                        break
                                    }
                                    list = __list
                                    finded = true
                                    break
                                } else {
                                    //未设定前置且这一批不足设定个数
                                    list = _list
                                    finded = true
                                    break
                                }
                            }
                        }
                        //不足设定个数时从后往前补齐
                        if (!finded) {
                            list = list.slice(list.length - ScreenCount, list.length)
                        }
                    }
                    //移动当前场次
                    var tab = list.length - 1
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].state != 3) {
                            tab = i
                            break
                        }
                    }
                    this.list = list
                    await this.tabChange(tab)
                    this.loading = false
                },
                async tabChange(i) {
                    if (i < 0) return
                    this.tab = i
                    try {
                        //请求促销状态信息
                        var screen = this.list[i]
                        if (screen.goods.length) {
                            var stateMap = {}
                            var ids = screen.goods.map(it => ({
                                promoId: it.promoId,
                                skuId: it.skuId
                            })).filter(it => it.promoId && it.skuId)
                            stateMap = await getPromotionState(ids,screen.state!=2)
                            screen.goods = screen.goods.filter(it => stateMap[it.skuId]).map(it => {
                                let state = stateMap[it.skuId]
                                return {
                                    ...it,
                                    jdPrice: formatPrice(state.jdPrice),
                                    promoPrice: formatPrice(state.promoPrice),
                                    promoPriceAvailable: state.promoPrice !== undefined && state.jdPrice != state.promoPrice,
                                    numAvailable: state.numAvailable,
                                    remainNumAvailable: state.remainNumAvailable,
                                    remainRate: state.numAvailable ? Math.round(state.remainNumAvailable / state.numAvailable * 100) : 0,
                                    saleAvailable: !!state.numAvailable || state.numAvailable === 0,
                                    discount: state.unit_discount || it.discount,
                                    saleOut: state.sellOutFlag,
                                }
                            })
                            const soldOutList = screen.goods.filter(v => v.saleOut); //售罄商品
                            const noRemainList = screen.goods.filter(v => !v.saleOut && !v.remainNumAvailable); //无货商品
                            let remainList = screen.goods.filter(v => !v.saleOut && v.remainNumAvailable); //有货商品
                            if (configData.shouldSort) {
                                // 商品排序逻辑
                                remainList = sort(remainList);
                            }
                            screen.goods = remainList.concat(noRemainList).concat(soldOutList); //无货商品沉底
                            this.list[i] = screen

                            //无货沉底逻辑
                            // var len = screen.goods.length
                            // for (let i = 0; i < len; i++) {
                            //     if (!screen.goods[i].remainNumAvailable) {
                            //         screen.goods.push(screen.goods[i])
                            //         screen.goods[i] = null
                            //     }
                            // }
                            // screen.goods = _.compact(screen.goods)
                        }
                    } catch (err) {
                        console.warn("促销状态获取错误", err)
                    }

                    /**
                     * 展示顺序排序
                     * 每个商品的isLocked属性排序优先（锁定位置）
                     * 接着是自动按remainRate排序
                     */
                    function sort(list) {
                        list = list.map((v, i) => {
                            v.index = i;
                            return v;
                        });

                        let lockedList = list.filter(v => v.isLocked === true);
                        let noLockedList = list.filter(v => v.isLocked !== true);

                        // 开启了自动排序，则对未锁定位置的商品进行一次针对remainRate的排序
                        noLockedList = noLockedList.sort((a, b) => {
                            return a.remainRate - b.remainRate
                        });
                        // 固定位置的也进行一次按照index的排序
                        lockedList = lockedList.sort((a, b) => a.index > b.index);

                        const result = list.reduce((acc, v, i) => {
                            if (lockedList.length && lockedList[0].index === i) {
                                acc = acc.concat(lockedList.shift());
                            } else {
                                if (noLockedList.length) {
                                    acc.push(noLockedList.shift());
                                } else {
                                    acc.push(lockedList.shift());
                                }
                            }
                            return acc;
                        }, []);

                        return result;
                    }
                },
                refreshTime() {
                    if (this.tab < 0) return
                    var list = this.list
                    for (let i = 0; i < list.length; i++) {
                        list[i].startTimeRemain = list[i].startTime - Date.now()
                        if (list[i].startTimeRemain < 0) {
                            list[i].startTimeRemain = 0
                        }
                        list[i].endTimeRemain = list[i].endTime - Date.now()
                        if (list[i].endTimeRemain < 0) {
                            list[i].endTimeRemain = 0
                        }
                        list[i].timeRemain = (list[i].state == 3 || list[i].state == 2) ? list[i].endTimeRemain : list[i].startTimeRemain
                        Vue.set(this.list, i, list[i])
                    }
                    if (list[this.tab].endTimeRemain == 0 && list[this.tab].state == 2) {
                        this.stateChange()
                    }
                }
            }
        })
    },
    destroyed() {
        if (this.instance) {
            this.instance.$destroy()
        }
    }
})